import { useListAsideStyles } from "./list-aside-styles"
import CloseIcon from "@mui/icons-material/Close"
import { Button, Paper, Drawer, IconButton, Typography, Box } from "@mui/material"
import clsx from "clsx"
import HiddenBox from "components/HiddenBox"
import React, { Dispatch, SetStateAction } from "react"

export enum ListAsideTypes {
  LIVESESSIONS = "LIVE SESSIONS",
  COLLEGES = "COLLEGES",
}

interface ListAsideProps {
  setIsDrawerOpen: Dispatch<SetStateAction<boolean>>
  isDrawerOpen: boolean
  type: ListAsideTypes
  children: React.ReactNode
}

const DesktopFilters = (props: ListAsideProps) => {
  const { classes } = useListAsideStyles()

  return (
    <Box display="flex" flexDirection="column" width="100%">
      <Box width="100%">
        <div className={clsx(classes.filtersRoot, classes.desktopFilters)}>
          <Paper elevation={2} classes={{ root: classes.filtersPaperRoot }}>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="space-between">
              <Typography className={classes.formTitle}>FILTER</Typography>
            </Box>
            {props.children}
          </Paper>
        </div>
      </Box>
    </Box>
  )
}

const MobileFilters = (props: ListAsideProps) => {
  const { classes } = useListAsideStyles()

  const closeDrawer = () => {
    props.setIsDrawerOpen(false)
  }

  return (
    <Drawer
      ModalProps={{
        keepMounted: true,
        disablePortal: true,
      }}
      anchor="left"
      open={props.isDrawerOpen}
      onClose={closeDrawer}>
      <Paper elevation={2} classes={{ root: classes.filtersPaperRoot }}>
        <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
          <Typography className={classes.formTitle}>FILTER</Typography>
          <div className={classes.closeIcon}>
            <IconButton onClick={closeDrawer} size="large">
              <CloseIcon />
            </IconButton>
          </div>
        </Box>
        {props.children}
        <Button
          onClick={closeDrawer}
          classes={{ root: classes.closeButton }}
          color="primary"
          variant="contained">
          CLOSE
        </Button>
      </Paper>
    </Drawer>
  )
}

export const ListAside = (props: ListAsideProps) => (
  <>
    <HiddenBox variant="hiddenSMDown">
      <DesktopFilters {...props} />
    </HiddenBox>
    <HiddenBox variant="hiddenMDUp">
      <MobileFilters {...props} />
    </HiddenBox>
  </>
)
